import React, { useEffect } from "react";

function GorgiasForm(isOpen) {
  useEffect(() => {
    if (isOpen) {
      // Ensure the script thinks it needs to initialize by clearing the flag
      // Otherwise the form won't load if you open the modal for the second time
      window.gorgiasContactForm = undefined;

      const script = document.createElement("script");
      script.src =
        "https://contact.gorgias.help/api/contact-forms/loader.js?v=3";
      script.defer = true;
      script.setAttribute("data-gorgias-loader-contact-form", true);

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isOpen]);

  return <div data-gorgias-contact-form-uid="n2f34qt5"></div>;
}

export default GorgiasForm;
